import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import {
  CForm,
  CFormLabel,
  CFormInput,
  CButton,
  CFormSelect,
} from '@coreui/react';
import { Link, useLoaderData, useNavigate, useRevalidator } from 'react-router-dom';
import axios from "axios";
import { getAttributeById, getAttributeBySlug } from 'src/store';
import dayjs from 'dayjs';
import AddHeaderSlider from 'src/components/headers/AddHeaderSlider';
import AxiosInstance from 'src/components/Axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import PageInfoList from 'src/components/page-info/PageInfoList';
import Tab from 'react-bootstrap/Tab';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import LangugesPanel from './LangugesPanel';
// import FormAttributes from 'src/components/attributes/FormAttributes';
import AddCategories from 'src/components/category/AddCategories';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import MediaFrom from 'src/components/media/MediaFrom';
import GalleryObject from 'src/components/gallery/GalleryObject';
import DatePicker from "react-datepicker";
import ScanningsList from 'src/components/scannings/ScanningsList';
import ModelsObjectNew from 'src/components/models/ModelsObjectNew';
import FormAttributesObject from 'src/components/attributes/FormAttributesObject';
import { findItemUpdated } from 'src/components/store/findInfo';
import { confirmAlert } from 'react-confirm-alert';
import Select, { components as RSComponents } from 'react-select';
import { selectLocationStyles } from 'src/styles/reactSelectStyles';

const tokenStr = localStorage.getItem('user');
const header = { headers: { "Authorization": `Bearer ${tokenStr}` } };

const navNames = {
  info: 'Загальні',
  models: 'Модель',
  img: 'Зображення',
  gallery: 'Галерея',
  attributes: 'Атрибути',
  category: 'Колекціі',
  data: 'Додаткові дані',
  scannings: 'Сканування',
};

// Додає зверху locations кастомний елемент
const makeMenuListWithLink = (label, to) => (props) => (
  <RSComponents.MenuList {...props}>
    <Link
      to={to}
      target='__blank'
      style={{
        display: 'block',
        padding: '8px 12px',
        textDecoration: 'none',
        fontFamily: 'Geist, sans-serif',
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '150%',
        cursor: 'pointer',
        textAlign: 'center'
      }}
    >
      {label}
    </Link>
    {props.children}
  </RSComponents.MenuList>
);

// Кастомний ValueContainer з кнопкою Translate
const ValueContainerWithTranslate = (props) => (
  <RSComponents.ValueContainer {...props}>
    <div style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative', minHeight: '38px', minWidth: '300px' }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', paddingRight: '80px' }}>
        {props.children}
      </div>
      {props.getValue().length > 0 && props.getValue()[0].value !== "" && (
        <button
          type="button"
          className='update-element'
          onClick={(e) => {
            e.stopPropagation();
            const url = "/attributes/variations/update/" + props.getValue()[0]?.value;
            window.location.href = url;
          }}
        >
          Update
        </button>
      )}
    </div>
  </RSComponents.ValueContainer>
);

export async function LoaderObjectsUpdate({ params }) {

  if (Object.keys(params).length != 0) {
    let res = await AxiosInstance.get('/objects/' + params.id, {
      params: {
        "g[0]": "objects:read",
        "g[1]": "objects:galleries",
        "g[2]": "objects:scanning",
        "g[3]": "objects:attributeItems",
        "g[4]": "objects:pageInfos"
      }
    }).then((response) => {
      return response;
    });
    return res;
  }
  return false;
}

const ObjectsForm = ({ user_data }) => {
  if (!Permissions(user_data, 'Objects', 'EDIT_OBJECTS')) {
    return <PermissionsNoPage />;
  }

  const { data } = useLoaderData();
  const revalidator = useRevalidator();
  const [name, setName] = useState((data != undefined) ? data.name : '');

  const [latitude, setLatitude] = useState((data != undefined) ? data.latitude : '');
  const [longitude, setLongitude] = useState((data != undefined) ? data.longitude : '');
  const [modelsObject,] = useState((data?.modelsObject != undefined) ? data.modelsObject : []);

  const [status, setStatus] = useState((data != undefined) ? data.status : '');
  const [language, setLaguage] = useState((data != undefined) ? data.language?.key : 'en');

  // const [sliders, setSliders] = useState((data != undefined && data.slider != undefined) ? data.slider.id : false);
  const [dateEntered, setDateEntered] = useState((data != undefined) ? new Date(data.dateEntered).toISOString() : new Date().toISOString());

  const [currentMedia, setCurrentMedia] = useState((data != undefined) && data.mainMedia);
  const [attrCategoryId, setAttrCategoryId] = useState();

  const [locationOptions, setLocationOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  //  Стейт для компоненту Location
  const dataCountry = findItemUpdated(data?.attributeItems, 'Country');
  const dataRegion = findItemUpdated(data?.attributeItems, 'Region');
  const dataSettlement = findItemUpdated(data?.attributeItems, 'Settlement');

  const [country, setCountry] = useState((dataCountry != undefined) ? { value: dataCountry?.id, label: dataCountry?.name, translations: dataCountry?.translations } : { label: "All countries", value: "", translations: [] });
  const [region, setRegion] = useState((dataRegion != undefined) ? { value: dataRegion?.id, label: dataRegion?.name, translations: dataRegion?.translations } : { label: "All regions", value: "", translations: [] });
  const [settlement, setSettlement] = useState((dataSettlement != undefined) ? { value: dataSettlement?.id, label: dataSettlement?.name, translations: dataSettlement?.translations } : { label: "All settelments", value: "", translations: [] });

  //  Для автозаповнення опцій локації згідно вибраного батьківського параметру
  const selectedRegion = getAttributeById(countryOptions, country.value);
  const dinamicRegions = getAttributeBySlug(locationOptions, `Region_${selectedRegion?.slug}`, language);
  
  const selectedSettelment = getAttributeById(dinamicRegions, region.value);
  const dinamicSettelment = getAttributeBySlug(locationOptions, `Settlement_${selectedSettelment?.slug}`, language);

  const popup = MyToastify();

  // стан для запису eventKey активного навлінка,показувати чи не показувати svg
  const [activeKey, setActiveKey] = useState('info')
  const [navLinkName, setNavLinkName] = useState('Загальні')


  const editorRef = useRef(null);
  const navigate = useNavigate();
  // Ключ для Editor
  const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;

  const handleSubmit = event => {
    event.preventDefault();

    const clearAttr = data?.attributeItems ? data.attributeItems.filter(attr => {
      return (attr.id !== dataCountry?.id && attr.id !== dataRegion?.id && attr.id !== dataSettlement?.id)
    }) : [];

    const formatAttr = [
      ...clearAttr.map((attr) => attr['@id']),
      ...(country?.value !== "" ? [`api/attribute_items/${country.value}`] : []),
      ...(region?.value !== "" ? [`api/attribute_items/${region.value}`] : []),
      ...(settlement?.value !== "" ? [`api/attribute_items/${settlement.value}`] : []),
    ];

    if (editorRef.current) {

      const article = {
        name: name,
        latitude: latitude,
        longitude: longitude,
        modelsObject: modelsObject,
        status: status,
        dateEntered: dateEntered,
        content: editorRef.current.getContent(),
        show: true,
        ...(data?.attributeItems !== undefined && {attributeItems: formatAttr})
      };

      if (data != undefined) {
        article.language = data.language ? `/api/languages/${data.language.id}` : `/api/languages/3`;
        axios.put(process.env.REACT_APP_SERVER_URL + '/api/objects/' + data.id, article, header).then(() => {
          popup.toastifySuccess('Загальні дані оновлено');
          revalidator.revalidate();
        });
      } else {
        article.language = `/api/languages/3`
        axios.post(process.env.REACT_APP_SERVER_URL + '/api/objects', article, header).then((response) => {
          navigate(`/objects/update/${response.data.id}`);
        });
      }
    }
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_SERVER_URL + '/api/attributes?pagination=false').then((response) => {
      const dataAttr = response.data['hydra:member'];
      const countryFilter = getAttributeBySlug(dataAttr, 'Country', data?.language?.key || 'en');
      setCountryOptions(countryFilter);
      setLocationOptions(dataAttr);
    })
  }, [data]);

  function changeMedia() {
    if (currentMedia && data.mainMedia !== null) {
      const oldId = data.mainMedia.id;
      AxiosInstance.put(`/objects/${data.id}`, { mainMedia: currentMedia['@id'] }).then((response) => {
        setCurrentMedia(response.data.mainMedia)
        popup.toastifySuccess('Зображення оновлено');
        AxiosInstance.delete(`/media_objects/${oldId}`); // видалення старої прив'язки
        revalidator.revalidate();
      })
    }
    else {
      AxiosInstance.put(`/objects/${data.id}`, { mainMedia: currentMedia['@id'] }).then((response) => {
        popup.toastifySuccess('Зображення оновлено');
        setCurrentMedia(response.data.mainMedia)
        revalidator.revalidate();
      })
    }
  }

  function deleteMedia() {
    confirmAlert({
      title: `Ви впевнені що хочете видалити фото ?`,
      message: '',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            if (currentMedia && data.mainMedia !== null) {
              AxiosInstance.put(`/objects/${data.id}`, { mainMedia: null }).then((response) => {
                popup.toastifySuccess('Зображення видалено');
                AxiosInstance.delete(`/media_objects/${currentMedia['id']}`).then(
                  setCurrentMedia(null)
                );
                revalidator.revalidate();
              })
            }
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }

  const datePicker = (value) => {
    let formattedDate = value.toISOString();
    setDateEntered(formattedDate);
  }

  useEffect(() => {
    AxiosInstance.get(`/categories`, {
      headers: { 'accept': 'application/json' }, params: {
        'g[0]': 'cat:read',
      }
    }).then((response) => {
      const [data] = response.data.filter(cat => (cat.type === 'attributes' && cat.slug === 'gen_attr'));
      if (data !== undefined) {
        setAttrCategoryId(data.id)
      }
    });
  }, [])

  function makeHidden() {
    if (data?.show) {
      confirmAlert({
        title: `Ви впевнені що хочете приховати об'єкт ?`,
        message: '',
        buttons: [
          {
            label: 'Так',
            onClick: () => {
              axios.put(process.env.REACT_APP_SERVER_URL + '/api/objects/' + data.id, { show: false }, header)
                .then(() => {
                  revalidator.revalidate();
                });
            }
          },
          {
            label: 'Ні',
            onClick: () => {
              return;
            }
          }
        ]
      });
    } else return
  }


  function makeVisible() {
    if (!data?.show) {
      confirmAlert({
        title: `Ви впевнені що хочете зробити об'єкт видимим ?`,
        message: '',
        buttons: [
          {
            label: 'Так',
            onClick: () => {
              axios.put(process.env.REACT_APP_SERVER_URL + '/api/objects/' + data.id, { show: true }, header)
                .then(() => {
                  revalidator.revalidate();
                });
            }
          },
          {
            label: 'Ні',
            onClick: () => {
              return;
            }
          }
        ]
      });
    } else return
  }

  return (
    <div className='component_wrapper'>
      <ToastContainer />
      <Tab.Container id="left-tabs-example" defaultActiveKey="info" onSelect={(key) => {
        setActiveKey(key);
        setNavLinkName(navNames[key]);
      }}>
        <Row>
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="info" className='styled_nav_link'>
                  {activeKey === 'info' &&
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>
                  }
                  Загальні</Nav.Link>
              </Nav.Item>
              {data !== undefined && <>
                <Nav.Item>
                  <Nav.Link eventKey="models" className='styled_nav_link'>
                    {activeKey === 'models' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Модель</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="img" className='styled_nav_link'>
                    {activeKey === 'img' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Зображення</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="gallery" className='styled_nav_link'>
                    {activeKey === "gallery" && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Галерея</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="attributes" className='styled_nav_link'>
                    {activeKey === 'attributes' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Атрибути</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="category" className='styled_nav_link'>
                    {activeKey === 'category' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Колекції</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="data" className='styled_nav_link'>
                    {activeKey === 'data' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Додаткові дані</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="scannings" className='styled_nav_link'>
                    {activeKey === 'scannings' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Сканування</Nav.Link>
                </Nav.Item>
              </>}
            </Nav>
          </Col>
          <Col sm={9}>
            <Tab.Content>
              <div style={{ display: 'flex' }}>
                <div className='tab-content-title'>
                  <h2 >{navLinkName}</h2>
                </div>
                <div className='col d-flex justify-content-end'>
                  {data !== undefined &&
                    <LangugesPanel data={data}
                      setLaguage={setLaguage}
                      language={language} />}
                </div>
              </div>
              <hr />
              {/* Вкладка Загальні */}
              <Tab.Pane eventKey="info">
                <CForm onSubmit={handleSubmit}>
                  <Row>
                    {currentMedia && <Col>
                      {/* Блок зображення */}
                      <>
                        <img
                          // className='object-img'
                          className='info-tab-image'
                          width={300} height={300} src={process.env.REACT_APP_SERVER_URL + currentMedia.contentUrl} />

                      </>
                      {/* Блок зображення */}
                    </Col>}
                    <Col
                    // className='info-col'
                    >
                      <div className="mb-3 info-col">
                        <CFormLabel className='info-name-title' htmlFor="exampleFormControlInput1">Name</CFormLabel>
                        <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" />
                      </div>

                      {data !== undefined && <div className="mb-3">
                        <div className='info-visibility-container'>
                          <h3 className='info-visibility-title'>
                            Object visibility
                          </h3>
                          <div className='info-visibility-buttons-container'>
                            <div className={`visible-info ${data?.show ? 'info-active-button' : ''}`} onClick={makeVisible}>
                              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_2001_8833)">
                                  <path d="M1.58301 9.99999C1.58301 9.99999 4.91634 3.33333 10.7497 3.33333C16.583 3.33333 19.9163 9.99999 19.9163 9.99999C19.9163 9.99999 16.583 16.6667 10.7497 16.6667C4.91634 16.6667 1.58301 9.99999 1.58301 9.99999Z" stroke="#181D27" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M10.7497 12.5C12.1304 12.5 13.2497 11.3807 13.2497 9.99999C13.2497 8.61928 12.1304 7.49999 10.7497 7.49999C9.36896 7.49999 8.24967 8.61928 8.24967 9.99999C8.24967 11.3807 9.36896 12.5 10.7497 12.5Z" stroke="#181D27" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2001_8833">
                                    <rect width="20" height="20" fill="white" transform="translate(0.75)" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span>Visible</span>
                            </div>

                            <div className={`hidden-info ${!data?.show ? 'info-active-button' : ''}`} onClick={makeHidden}>

                              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_2001_8851)">
                                  <path d="M8.83366 3.53333C9.40727 3.39906 9.99454 3.33194 10.5837 3.33333C16.417 3.33333 19.7503 9.99999 19.7503 9.99999C19.2445 10.9463 18.6412 11.8373 17.9503 12.6583M12.3503 11.7667C12.1215 12.0123 11.8454 12.2093 11.5388 12.3459C11.2321 12.4826 10.9011 12.556 10.5654 12.562C10.2297 12.5679 9.89629 12.5061 9.585 12.3804C9.27371 12.2547 8.99093 12.0675 8.75353 11.8301C8.51613 11.5927 8.32899 11.3099 8.20325 10.9987C8.07751 10.6874 8.01576 10.3539 8.02169 10.0183C8.02761 9.68258 8.10108 9.35153 8.23772 9.04487C8.37436 8.7382 8.57137 8.4622 8.81699 8.23333M1.41699 0.833328L19.7503 19.1667M15.5337 14.95C14.1091 16.0358 12.3746 16.6374 10.5837 16.6667C4.75033 16.6667 1.41699 9.99999 1.41699 9.99999C2.45357 8.06824 3.89127 6.3805 5.63366 5.04999L15.5337 14.95Z" stroke="#181D27" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2001_8851">
                                    <rect width="20" height="20" fill="white" transform="translate(0.583984)" />
                                  </clipPath>
                                </defs>
                              </svg>

                              <span>Hidden</span>
                            </div>
                          </div>
                        </div>
                      </div>}
                    </Col>
                  </Row>
                  {/* Опис */}
                  <div className="mb-3" style={{ marginTop: '40px' }}>
                    <h3 className='editor-title'>Description</h3>
                    <Editor
                      apiKey={apiKey}
                      onInit={(evt, editor) => editorRef.current = editor}
                      initialValue={(data != undefined) ? data.content : ''}
                      init={{
                        height: 300,
                        menubar: 'edit view insert format',
                        plugins: [
                          'advlist', 'autolink',
                          'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
                          'insertdatetime', 'media', 'table', 'help', 'code'
                        ],
                        toolbar: 'undo redo | fontfamily fontsize | fontselect | bold italic backcolor | ' +
                          'alignleft aligncenter alignright alignjustify | ' +
                          'bullist numlist checklist outdent indent | removeformat | link media a11ycheck code table help',
                        content_style: 'body { font-family:FixelDisplayRegular; font-size:14px }',
                        font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Fixel Display Regular=fixelDisplayRegular; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                      }}
                    />
                  </div>
                  {/* Опис */}

                  <div
                    // className="mb-3" 
                    style={{ marginBottom: '40px' }}>
                    <div className='location-title'>
                      <h2>Location</h2>
                    </div>
                    <hr />

                    <Row >
                      <Col className='info-col'
                      // className="col"
                      >
                        <CFormLabel htmlFor="exampleFormControlInput1">Longitude</CFormLabel>
                        <CFormInput type="number" id="exampleFormControlInput1" value={longitude} onChange={(e) => setLongitude(e.target.value)} autoComplete="off" />
                      </Col>
                      <Col className='info-col'
                      // className="col"
                      >
                        <CFormLabel htmlFor="exampleFormControlInput1">Latiude</CFormLabel>
                        <CFormInput type="number" id="exampleFormControlInput1" value={latitude} onChange={(e) => setLatitude(e.target.value)} autoComplete="off" />
                      </Col>
                    </Row>

                    {data !== undefined && <>
                    <Row className='mt-4'>
                        <Col className='location-col'>
                          <CFormLabel htmlFor="exampleFormControlInput1">Country</CFormLabel>
                          <Select id="constrolSelect" placeholder="Country" 
                            options={countryOptions?.attributeItems !== undefined ? [{ label: "All countries", value: "", translations: [] }, 
                              ...countryOptions.attributeItems.map((option)=> {return { label:option.name, value: option.id, translations: option.translations }})] : []}
                            value={country} 
                            onChange={(e) => {
                              setCountry(e); 
                              setRegion({ label: "All regions", value: "" }); 
                              setSettlement({ label: "All settelment", value: "" })}} 
                            styles={{
                              ...selectLocationStyles,
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999
                              }),
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999
                              })
                            }}
                            isDisabled={countryOptions?.attributeItems === undefined}
                            components={{ 
                              MenuList: makeMenuListWithLink('Create new country', `/attributes/update/${countryOptions?.id}`),
                              // ...(country.translations?.length === 0 && { ValueContainer: ValueContainerWithTranslate })
                              ValueContainer: ValueContainerWithTranslate
                            }}
                            menuPlacement='auto' />
                        </Col>
                        <Col className='location-col'>
                          <CFormLabel htmlFor="exampleFormControlInput1">Region</CFormLabel>
                          <Select id="constrolSelect" placeholder="Region" 
                            options={dinamicRegions?.attributeItems !== undefined ? [{ label: "All regions", value: "", translations: [] }, 
                              ...dinamicRegions.attributeItems.map((option)=> {return { label:option.name, value: option.id, translations: option.translations  }})] : []}
                            value={region} 
                            onChange={(e) => {
                              setRegion(e); 
                              setSettlement({ label: "All settelment", value: "" })}} 
                            styles={{
                              ...selectLocationStyles,
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999
                              }),
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999
                              })
                            }}
                            components={{ 
                              MenuList: makeMenuListWithLink('Create new region', `/attributes/update/${dinamicRegions?.id}`),
                              // ...(region.translations?.length === 0 && { ValueContainer: ValueContainerWithTranslate }) 
                              ValueContainer: ValueContainerWithTranslate
                            }}
                            isDisabled = {dinamicRegions?.attributeItems === undefined}
                            menuPlacement='auto' />
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                      <Col className='location-col'>
                        <CFormLabel htmlFor="constrolSelect">Settlement</CFormLabel>
                          <Select id="constrolSelect" placeholder="Settlement" 
                            options={dinamicSettelment?.attributeItems !== undefined ? [{ label: "All settelment", value: "", translations: [] }, 
                            ...dinamicSettelment.attributeItems.map((option)=> {return { label:option.name, value: option.id, translations: option.translations }})] : []}
                            value={settlement} 
                            styles={{
                              ...selectLocationStyles,
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999
                              }),
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999
                              })
                            }}
                            onChange={(e) => setSettlement(e)} 
                            components={{ 
                              MenuList: makeMenuListWithLink('Create new settlement', `/attributes/update/${dinamicSettelment?.id}`),
                              // ...(settlement.translations?.length === 0 && { ValueContainer: ValueContainerWithTranslate })  
                              ValueContainer: ValueContainerWithTranslate
                            }}
                            isDisabled = {dinamicSettelment?.attributeItems === undefined}
                            menuPlacement='auto' />
                      </Col>
                    </Row>
                    </>}

                  </div>
                  <div className="mb-3 info-col">
                    <CFormLabel htmlFor="exampleFormControlInput1">Дата створення</CFormLabel>
                    <DatePicker
                      className="form-control"
                      dateFormat="yyyy-MM-dd"
                      selected={new Date(dateEntered)}
                      onChange={(date) => datePicker(date)}
                      disabled
                    />

                  </div>
                  <div className="mb-3 info-col">
                    <CFormSelect
                      aria-label="Default select example"
                      onChange={(e) => setStatus(e.target.value)}
                      defaultValue={status}
                      required
                      options={[
                        { label: 'Статус', value: '' },
                        { label: 'Completed', value: 'Completed' },
                        { label: 'Planned', value: 'Planned' },
                        { label: 'Pending', value: 'Pending' }
                      ]}
                    />
                  </div>
                  <CButton
                    className='item_add_button'
                    type="submit"
                    color="success">
                    {/* Зберегти */}
                    Save
                  </CButton>
                </CForm>

              </Tab.Pane>
              {/* Вкладка Загальні */}
              {data !== undefined &&
                <>
                  <Tab.Pane eventKey="models">
                    <ModelsObjectNew dataId={data.id} popup={popup} currentModels={modelsObject} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="img">
                    <MediaFrom type="materials" newMedia={currentMedia} setNewMedia={setCurrentMedia} toastifySuccess={popup.toastifySuccess} />
                    {currentMedia && <>
                      <img className='object-img' width={300} height={300} src={process.env.REACT_APP_SERVER_URL + currentMedia.contentUrl} />
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <CButton type="submit" onClick={changeMedia} className="my-3 item_add_button_type1" color="success">
                          Зберегти Зображення
                        </CButton>
                        <CButton
                          // type="submit"
                          className="my-3"
                          onClick={() => {
                            deleteMedia()
                          }}
                          style={{ order: '2', height: '40px' }}
                          // className="my-3 item_add_button_type1"
                          color="danger">
                          Видалити Зображення
                        </CButton>
                      </div>
                    </>}
                  </Tab.Pane>
                  <Tab.Pane eventKey="gallery">
                    <GalleryObject dataId={data.id} popup={popup} typeChain={'objects'} currentGalleries={data.galleries} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="attributes">
                    {attrCategoryId !== undefined && 
                      <FormAttributesObject
                        language={language} 
                        dataId={data.id} 
                        attributeItems={data.attributeItems} 
                        toastifySuccess={popup.toastifySuccess} 
                        categorieID={attrCategoryId} 
                        type="products" 
                        url="/objects" 
                    />}
                  </Tab.Pane>
                  <Tab.Pane eventKey="category">
                    <AddCategories type="objects" data_id={data.id} toastifySuccess={popup.toastifySuccess} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="data">
                    <PageInfoList id={data.id} type="object" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="scannings">
                    <ScanningsList id={data.id} languageID = {data.language.id} />
                  </Tab.Pane>
                </>}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
      {/* <AddHeaderSlider id={(sliders !== false) ? sliders : undefined} newSlider={setSliders} parentUrl={`objects/${data.id}`}/>   */}
      {/* {(data != undefined)&&
        <PageInfoList id={data.id} type="project" />
      } */}
    </div>
  );
};

export default ObjectsForm;
